import React, {useContext, useEffect} from 'react';
import Icon from './images/arrow-to-top.svg';

function ScrollTop(props) {
  const {sticky, showOnProduct} = props;
  const [show, setShow] = React.useState(sticky);

  useEffect(() => {
    setShow(sticky);
  }, [sticky])

  return (
    <div className={`${show || showOnProduct
      ? 'fixed'
      : 'hidden'} rounded-full border border-solid border-[#6364FF] flex items-center justify-center bg-white bottom-[90px] right-[32px] cursor-pointer z-10 w-[50px] h-[50px] shadow-[0px_2px_4px_0px_rgba(0,0,0,0.18)]`}
         onClick={() => {
            window.document.body.scrollIntoView({block: "start", behavior: "smooth"});
         }}
    >
      <img src={Icon}/>
    </div>
  );
}

export default ScrollTop;